var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMservice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 1h16v5h-2V3H6v18h12v-5h2v7H4zm9 7h11v2H13zm0 4h8v2h-8zm-2 5h2.004v2.004H11z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMservice);
export default __webpack_public_path__ + "static/media/mservice.03fcdb3637297637486334d850a8ec70.svg";
export { ForwardRef as ReactComponent };